import { action, observable } from "mobx";
import { ModelBase } from "@shoothill/core";
import { PackageCategoriesResult } from "Views/PurchaseOrder/PackageCategoriesResult";

export class REFilterParamsModel extends ModelBase<REFilterParamsModel, REFilterParamsModelDTO> {
    @observable
    public includeDeleted: boolean = false;

    @observable
    public categories: number[] | null = [];

    @observable
    public subCategories: number[] | null = [];

    @observable
    public statuses: string[] | null = []; //[100, 200, 300]

    @observable
    public orderTypes: string[] | null = []; //[100, 200]

    @observable
    public cells: number[] | null = [];

    @observable
    public raisedByIds: string[] | null = [];

    @observable
    public projects: string[] | null = [];

    @observable
    public searchText: string = "";

    fromDto(model: REFilterParamsModelDTO): void {
        this.categories = model.categories;
        this.subCategories = model.subCategories;
        this.searchText = model.searchText;
    }

    toDto(): REFilterParamsModelDTO {
        let dto: REFilterParamsModelDTO = {
            includeDeleted: this.includeDeleted,
            categories: this.categories,
            subCategories: this.subCategories,
            statuses: this.statuses,
            orderTypes: this.orderTypes,
            cells: this.cells,
            raisedByIds: this.raisedByIds,
            projects: this.projects,
            searchText: this.searchText,
        };
        return dto;
    }

    @action
    public setCategoriesAndSubFilters = (result: PackageCategoriesResult) => {
        if (result !== null && result.categories !== null && result.categories.length > 0) {
            this.categories = result.categories.map((a: { id: any }) => a.id);
        }

        if (result !== null && result.subCategories !== null && result.subCategories.length > 0) {
            this.subCategories = result.subCategories.map((a: { id: any }) => a.id);
        }
    };

    @action
    public reset = () => {
        this.categories = [];
        this.subCategories = [];
        this.statuses = [];
        this.orderTypes = [];
        this.cells = [];
        this.raisedByIds = [];
        this.searchText = "";
    };
}

export interface REFilterParamsModelDTO {
    includeDeleted: boolean;
    categories: number[] | null;
    subCategories: number[] | null;
    statuses: string[] | null;
    orderTypes: string[] | null;
    cells: number[] | null;
    raisedByIds: string[] | null;
    projects: string[] | null;
    searchText: string;
}
